import { useState } from "react";
import { useSelector } from "react-redux";

const ImagePreview = ({ resource }) => {
  const theme = useSelector((state) => state.theme.myTheme);
  const [element, setElement] = useState();

  const onHover = () => {
    setElement(renderPreview());
  };

  const onUnHover = () => {
    setElement(undefined);
  };

  const renderPreview = () => {
    return (
      <div className="absolute rounded-lg pt-2 px-2" style={{ zIndex: 2, paddingBottom: "3px", background: theme.darken }} onMouseLeave={() => onUnHover()}>
        <img src={resource} alt="ImageCapture" style={{ height: "20rem", objectFit: "contain", background: theme.primary }} className="rounded-lg" />
      </div>
    );
  };

  return (
    <div className="relative d-flex justify-center align-center">
      <img src={resource} alt="ImageCapture" style={{ width: "10rem", height: "10rem", objectFit: "cover" }} className="rounded-lg" onMouseEnter={() => onHover()} />
      {element}
    </div>
  );
};

export default ImagePreview;
